/**
 * /publishers/api-toggle — admin API access console (FS-154 / DASH).
 *
 * Flat-file TanStack Router route: dots map to slashes, so
 * `publishers.api-toggle.tsx` mounts at `/publishers/api-toggle`. Delegates
 * all rendering to `PublisherApiTogglePage` so the route file stays a thin
 * wiring shim.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { PublisherApiTogglePage } from "@/features/publisher-api-toggle/PublisherApiTogglePage";

// ---------------------------------------------------------------------------
// Search params — optional `affiliateId` deep-link so admins can land on a
// pre-selected affiliate (e.g. from an affiliate drilldown screen).
// ---------------------------------------------------------------------------

interface PublisherApiToggleSearch {
	affiliateId?: string;
}

export const publishersApiToggleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publishers/api-toggle",
	validateSearch: (raw: Record<string, unknown>): PublisherApiToggleSearch => {
		const v = raw.affiliateId;
		if (typeof v === "string" && v.trim().length > 0) {
			return { affiliateId: v.trim() };
		}
		return {};
	},
	component: PublisherApiTogglePage,
});

export default publishersApiToggleRoute;

// Re-export for convenience so the shared router wire-up can import either
// the route or the page component from a single module path.
export { PublisherApiTogglePage } from "@/features/publisher-api-toggle/PublisherApiTogglePage";
